import app from '../../firebase';
import { getFirestore, collection, getDocs, query, limit, orderBy, where } from 'firebase/firestore';
import { useState, useEffect } from 'react';

export default function ProfileProducts() {
    
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' });

    const [recentProducts, setRecentProducts]   = useState();
    const [furnitures, setFurnitures]           = useState();
    const [condominium, setCondominium]         = useState();
    const [services, setServices]               = useState();

    const getRecentProducts = async () => {
        let x = [];
        await getDocs(query(collection(getFirestore(app), 'products'), orderBy('date', 'desc')))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setRecentProducts(x);
    }

    const getFurnitures = async () => {
        let x = [];
        await getDocs(query(collection(getFirestore(app), 'products'), where('category', '==', 'Furnitures'), limit(4)))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setFurnitures(x);
    }

    const getCondominium = async () => {
        let x = [];
        await getDocs(query(collection(getFirestore(app), 'properties'), where('category', '==', 'Condominium'), limit(4)))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setCondominium(x);
    }

    const getServices = async () => {
        let x = [];
        await getDocs(query(collection(getFirestore(app), 'services'), limit(4)))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setServices(x);
    }

    useEffect(() => {
        getRecentProducts();
        getFurnitures();
        getCondominium();
        getServices();
        console.log('WORKING')
    }, []);
    
    return(
        <>
            <div className="container-fluid bg-light p-4">
                <div className="row g-0">

                    <div className="col-12 col-lg-4">
                        <div className="p-2">
                            <h3>Furniture</h3>
                            <div className="row g-3 text-center">
                                {
                                    furnitures && furnitures.map(i => (
                                        <div className="col-6">
                                            <a href={`/product/${i[0]}`}>
                                                <img src={i[1].image_url} className="img-fluid shadow w-100 mb-2" style={{ borderRadius: 10 }} alt={i[1].name} />
                                                <small className="d-none d-md-block fw-bold text-success">{formatter.format(i[1].price)}</small>
                                            </a>
                                        </div>
                                    ))
                                }
                            </div>

                            <br />

                            <button
                                className="btn btn-dark w-100"
                                onClick={() => {
                                    localStorage.setItem('search_bullet', JSON.stringify({ category: 'Furnitures', keywords: [] }));
                                    window.location.replace('/products');
                                }}
                            >View More</button>
                        </div>
                    </div>

                    <div className="col-12 col-lg-4">
                        <div className="p-2">
                            <h3>Condominium</h3>
                            <div className="row g-3 text-center">
                                {
                                    condominium && condominium.map(i => (
                                        <div className="col-6">
                                            <a href={`/property/${i[0]}`}>
                                                <img src={i[1].image_url} className="img-fluid shadow w-100 mb-2" style={{ borderRadius: 10 }} alt={i[1].name} />
                                                <small className="d-none d-md-block fw-bold text-success">{formatter.format(i[1].price)}</small>
                                            </a>
                                        </div>
                                    ))
                                }
                            </div>

                            <br />

                            <button
                                className="btn btn-dark w-100"
                                onClick={() => {
                                    localStorage.setItem('search_bullet', JSON.stringify({ category: 'Condominium', keywords: [] }));
                                    window.location.replace('/properties');
                                }}
                            >View More</button>
                        </div>
                    </div>

                    <div className="col-12 col-lg-4">
                        <div className="p-2">
                            <h3>Service</h3>
                            <div className="row g-3 text-center">
                                {
                                    services && services.map(i => (
                                        <div className="col-6">
                                            <a href={`/service/${i[0]}`}>
                                                <img
                                                    src={i[1].image_url}
                                                    className="img-fluid shadow w-100 mb-2"
                                                    style={{ borderRadius: 10 }}
                                                    alt={i[1].name}
                                                />

                                                <small className="d-none d-md-block fw-bold text-success">{formatter.format(i[1].price)}</small>
                                            </a>
                                        </div>
                                    ))
                                }
                            </div>

                            <br />

                            <button
                                className="btn btn-dark w-100"
                                onClick={() => {
                                    localStorage.setItem('search_bullet', JSON.stringify({ category: 'Condominium', keywords: [] }));
                                    window.location.replace('/services');
                                }}
                            >View More</button>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}